/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
==========================================================================================*/

import jwtArticle from "../../http/requests/article/index.js"
import indexCommande from '../../http/requests/commande/index.js'
import store from "../store.js";

export default {
  fetchArticles({ commit }) {
    console.log("fetch articles")
    jwtArticle.GetAll()
      .then(response => {
      
        commit('UPDATE_ARTICLE', response.data)
      }).catch(() => {

      });
  },
  fetchClients({ commit }) {
    indexCommande.GetClients()
      .then(response => {
        commit('UPDATE_CLIENT', response.data)

      }).catch(() => {

      });
  },
  getListFilters({ commit }) {
    jwtArticle.getListFilters().then(response => {
      commit('UPDATE_FILTERS', response.data)
    })
  },
  fetchClientAnaltcsData({ commit }) {
    jwtArticle.getClientAnaltcsData(store.state.AppActiveUser.customer_No).then(response => {
    
      commit('UPDATE_ANALTCS_DATA', response.data)
    })
    indexCommande.GetEntete(store.state.AppActiveUser.customer_No).then(response=>{
      commit('UPDATE_CURRENT_CLIENT_INFO',response.data)
    })

  },
  UPDATE_PERIODE({ commit }, payload) {
   
    commit('UPDATE_PERIODE', payload)
  }, 
  UPDATE_PERIODE_YEAR({ commit }, payload) {
    
    commit('UPDATE_PERIODE_YEAR', payload)
  }
}

